var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _vm.isLoading
        ? _c("base-loading")
        : _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { xl: "12", lg: "12", md: "12", sm: "12", xs: "12" } },
                [
                  _c(
                    "b-row",
                    [_c("lineage-bi", { attrs: { datos: _vm.data_lineage } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }